export default __webpack_public_path__ + "static/bunker-nextImage-8b2d708cf1fa5cadea6a2a4383b94741.jpg";